// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"78":"0e5b8875","542":"5453d981"}[chunkId] + ".js";
};